import axios from 'axios'
import OneSignal from 'react-onesignal'

export const runOneSignal = async () => {
  const user = JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData')) : ''
  await OneSignal.init({
    appId: process.env.REACT_APP_ONE_SIGNAL_APP_ID,
    allowLocalhostAsSecureOrigin: true
  }).catch(error => {
    console.log(error, 'test')
  })
  console.log(user)
  await OneSignal.login(user?.id ? `${user?.id}` : '')
  await OneSignal.Slidedown.promptPush()
  sendToken(OneSignal.User.PushSubscription.id)
}

const sendToken = token => {
  if (token) {
    localStorage.setItem('onesignal_Id', token)
    // Perform any other neccessary action with the token
    const user = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : ''
    let machineId = localStorage.getItem('MachineId')
    if (!machineId) {
      machineId = crypto.randomUUID()
      localStorage.setItem('MachineId', machineId)
    }
    axios
      .post(
        process.env.REACT_APP_BASE_URL + '/api/dashboard/superAdmin/notifications/update_fcm',
        {
          fcm_token: token,
          device_id: machineId,
          device_type: 1
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`
          }
        }
      )
      .then(res => {
        return res
      })
  }
}
